import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';
import Analytics from '@/components/Analytics';
import ProtectedRoute from '@/components/ProtectedRoute';

// Basic Pages (Static)
import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import Training from '@/pages/Training';
import Sustainability from '@/pages/Sustainability';
import Sectors from '@/pages/Sectors';
import News from '@/pages/News';
import NewsArticle from '@/pages/NewsArticle';
import Contact from '@/pages/Contact';

// Heavy Modules (Lazy Loaded)
const Admin = lazy(() => import('@/pages/Admin'));
const TeamPortal = lazy(() => import('@/pages/TeamPortal'));

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <ScrollToTop />
        <Analytics />
        <Navbar />
        
        <main className="flex-grow">
          <Suspense fallback={
            <div className="min-h-[60vh] flex items-center justify-center">
              <div className="w-10 h-10 border-4 border-[#0A5F7F] border-t-transparent rounded-full animate-spin"></div>
            </div>
          }>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/quienes-somos" element={<About />} />
              <Route path="/servicios" element={<Services />} />
              <Route path="/capacitacion" element={<Training />} />
              <Route path="/sostenibilidad" element={<Sustainability />} />
              <Route path="/sectores" element={<Sectors />} />
              <Route path="/noticias" element={<News />} />
              <Route path="/noticias/:slug" element={<NewsArticle />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/contact" element={<Contact />} />

              {/* Admin Routes (Lazy) */}
              <Route path="/admin" element={<Admin />} />

              {/* Team/Protected Routes (Lazy) */}
              <Route 
                path="/equipo" 
                element={
                  <ProtectedRoute>
                    <TeamPortal />
                  </ProtectedRoute>
                } 
              />
              
              {/* Catch-all route */}
              <Route path="*" element={<Home />} />
            </Routes>
          </Suspense>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
